import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import actions from './actions'
import mutations from './mutations'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

const getters = {
    events: state => state.events,
    weekendsVisible: state => state.weekendsVisible,
    scrollbarHide: state => state.hide_scroll,
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
    userProfile: state => state.userProfile,
    empId: state => state.empId,
    userId: state => state.userId,
    callingAPI:state =>state.callingAPI,
    isMultiple:state=>state.isMultiple,
    companySettings:state=>state.company_setting,
    photo_profile:state=>state.photo_profile,
    menus:state=>state.menus
}
export default new Vuex.Store({
    plugins:[createPersistedState()],
    state,
    actions,
    getters,
    mutations
})